import { render } from "./CharacterAptitudes.vue?vue&type=template&id=3fa51500&scoped=true"
import script from "./CharacterAptitudes.vue?vue&type=script&lang=js"
export * from "./CharacterAptitudes.vue?vue&type=script&lang=js"

import "./CharacterAptitudes.vue?vue&type=style&index=0&id=3fa51500&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa51500"]])

export default __exports__